import { ReactElement } from "react";
import { Typography, Avatar } from "@mui/material";
import { convertUserImage } from "../../../util/utils";

interface Props {
  suggestion: any;
}

export default function PostRefSuggestion({ suggestion }: Props): ReactElement {
  return (
    <div style={styles.container}>
      <div style={styles.userInfo}>
        <Avatar
          alt="Remy Sharp"
          src={convertUserImage(suggestion?.user?.image)}
        />
        <Typography style={styles.userName}>
          {suggestion?.user?.nickname}
        </Typography>
      </div>

      <div style={styles.content}>
        {suggestion?.title}
      </div>
    </div>
  );
}

const styles = {
  container: {
    marginTop: "50px",
    position: "fixed" as const,
    top: 0,
    right: 0,
    width: "30%",
    height: "calc(100% - 50px)",
    overflowY: "auto" as const,
  },

  userInfo: {
    display: "flex",
    padding: "20px 20px 0",
  },

  userName: {
    lineHeight: "40px",
    paddingLeft: "20px",
    userSelect: "text" as const,
  },

  content: {
    padding: "20px",
    whiteSpace: "pre-wrap" as const,
    wordWrap: "break-word" as const,
    userSelect: "text" as const,
  },
};
